import { Typography, useModal } from '@aloft/toolkit-sui';
import { useQueryClient } from '@tanstack/react-query';

import {
  UpdatePairedSalesStudyError,
  useUpdatePairedSalesStudy,
} from '../../../hooks/api/toolkitComponents.ts';
import { useToaster } from '../../../hooks/useToaster/useToaster.tsx';

export const useDeleteStudyModal = (id: string, studyType: string) => {
  const makeToast = useToaster();
  const handleError = (err: Error | UpdatePairedSalesStudyError) => {
    console.warn(err);
    makeToast({
      type: 'error',
      id: 'delete-study-error',
      title: 'Error deleting study',
    });
  };

  const { Modal, openModal, isModalOpen, closeModal } = useModal();

  const queryClient = useQueryClient();

  const { mutate } = useUpdatePairedSalesStudy({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['api', 'v2', 'pairedSales'],
      });
      closeModal();
    },
    onError: handleError,
  });

  const deleteStudy = () => {
    try {
      mutate({
        pathParams: { studyID: id },
        body: { isDeleted: true },
      });
    } catch (err) {
      handleError(err as Error);
    }
  };

  const DeleteStudyModal = isModalOpen ? (
    <Modal
      isOpen={isModalOpen}
      onClose={closeModal}
      primaryAction={{
        text: 'Delete Study',
        onClick: deleteStudy,
      }}
      secondaryAction={{ text: 'Cancel', onClick: closeModal }}
    >
      <Typography variant="h1">Confirm Study Deletion</Typography>
      <Typography variant="body1">{`Are you sure you want to delete the ${studyType} study? This action cannot be undone.`}</Typography>
    </Modal>
  ) : null;

  return { Modal: DeleteStudyModal, openModal };
};
